import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import reducers from '../reducers';

const enhancer = applyMiddleware(thunk);

function configureStore(initialState) {
    return createStore(reducers, initialState, enhancer);
}

export default configureStore;